import React, { Component } from 'react';
import { FormSpy } from 'react-final-form';
import isEqual from 'lodash/isEqual';


class AutoSave extends Component {
  constructor(props) {
    super(props)
    this.state = { values: props.values, submitting: false }
  }

  componentWillReceiveProps(nextProps) {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    this.timeout = setTimeout(this.save, this.props.debounce)
  }

  save = async () => {
    if (this.promise) {
      await this.promise
    }
    const { values, save } = this.props
    
    if (!isEqual(this.state.values, values)) {
      this.setState({ submitting: true, values })
      this.promise = save(values)
      await this.promise
      delete this.promise
      this.setState({ submitting: false })
    }
  }

  render() {
    return null
  }
}

export default props => (
  <FormSpy {...props} subscription={{ values: true }} component={AutoSave} />
)


// WEBPACK FOOTER //
// ./src/components/form/AutoSave.js